import { render, staticRenderFns } from "./BranchConfirmQR.vue?vue&type=template&id=e506d006&scoped=true&"
import script from "./BranchConfirmQR.vue?vue&type=script&lang=ts&"
export * from "./BranchConfirmQR.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e506d006",
  null
  
)

export default component.exports